<template>
  <article v-if="sortedChapters" class="flex flex-col font-roboto">
    <div
      v-if="!sortedChapters.length"
      class="flex items-center justify-center py-[5vh]"
    >
      Материалы не найдены
    </div>
    <div class="relative flex flex-col lg:flex-row">
      <!-- <the-teacher-navigate
        :list="sortedChapters"
        :active-chapter="activeChapter"
        class="lg:hidden w-full mb-5"
        @onActiveChapter="handleActiveChapter"
      /> -->
      <BaseTheAccordeon
        :data="sortedChapters"
        :active-chapter="activeChapter"
        :active-chapters="activeChapters"
        :active-highlight="activeHighlight"
        :icons="icons"
        segment="teacher"
        class="flex-1"
        @on-active="handleActiveChapter"
      />
      <BaseTheTeacherNavigate
        :list="sortedChapters"
        :active-chapter="activeChapter"
        class="sticky top-24 ml-5 hidden h-fit w-full max-w-[290px] lg:block"
        @on-active-chapter="handleActiveChapterNavigate"
      />
    </div>
  </article>
</template>

<script setup>
definePageMeta({ layout: 'marginless' });

const props = defineProps({
  category: { type: Object, default: () => ({}) },
});

const icons = [
  'article',
  'videomaterial',
  'audiomaterial',
  'test',
  'wiki',
  'document_collection',
  'book',
  'date',
  ...(props.category?.shelf_id === 7
    ? ['presentation']
    : []) /*'presentation',*/,
  // 'illustration',
];

const crumbsStore = useBreadcrumbsStore();
const route = useRoute();
const router = useRouter();

const activeChapter = ref(null);
const activeChapters = ref([]);
const activeHighlight = ref(null);

const chapters = computed(() => {
  return props.category.chapters;
});

const sortedChapters = computed(() => {
  if (!chapters.value) return;
  const numbered = [...chapters.value].filter(({ number }) => !!number);
  const unnumbered = [...chapters.value].filter(({ number }) => !number);

  return [...numbered, ...unnumbered];
});

watch(
  activeChapters,
  (val) => {
    if (!val.length) {
      activeChapter.value = null;
      return;
    }
    activeChapter.value = val.at(-1);
  },
  { deep: true },
);

onMounted(() => {
  const category = route.query?.category;
  if (!category || !sortedChapters.value) return;
  Array.from(sortedChapters.value).forEach((chapter, idx) =>
    chapter.highlights.forEach((highlight) => {
      if (highlight.slug === category) {
        activeChapters.value.push(idx);
        activeChapter.value = idx;
        activeHighlight.value = highlight.slug;
      }
    }),
  );
});

const setCrumbsActiveChapter = (e) => {
  const chaptersCrumb = activeChapters.value.includes(e)
    ? {
        title: chapters.value[e]?.number
          ? `Глава ${chapters.value[e]?.number}. ${chapters.value[e].title}`
          : chapters.value[e].title,
        slug: `/teacher/${props.category?.slug}`,
      }
    : activeChapters.value?.length
    ? {
        title: chapters.value[activeChapters.value.at(-1)]?.number
          ? `Глава ${chapters.value[activeChapters.value.at(-1)]?.number}. ${
              chapters.value[activeChapters.value.at(-1)].title
            }`
          : chapters.value[activeChapters.value.at(-1)].title,
        slug: `/teacher/${props.category?.slug}`,
      }
    : null;

  crumbsStore.setCrumbs({
    key: 'chapter',
    value: chaptersCrumb,
  });
};

const handleActiveChapter = (e) => {
  if (activeChapters.value.includes(e)) {
    activeChapters.value = activeChapters.value.filter(
      (chapter) => chapter !== e,
    );
    activeChapter.value = null;
  } else {
    activeChapters.value.push(e);
  }

  activeChapter.value = e;
  if (route.query?.category) router.replace({ query: null });

  setCrumbsActiveChapter(e);
};

const handleActiveChapterNavigate = (e) => {
  if (!activeChapters.value.includes(e)) {
    activeChapters.value.push(e);
  }
  activeChapter.value = e;
  if (route.query?.category) router.replace({ query: null });

  setCrumbsActiveChapter(e);
};

useHead(
  computed(() => ({
    title: `История РФ: ${
      props.category?.title
        ? `${props.category.title} ${props.category?.school_class?.title}`
        : ''
    } | Материалы по истории для школьного курса «История России» и «Всеобщая история» с 5 по 11 класс`,
    meta: [
      {
        name: 'description',
        content:
          'История Российской Федерации в статьях. Освещаем все вехи российской истории в статьях. Российское военно-историческое общество. Мы знаем правду.',
      },
      {
        name: 'keywords',
        content: 'История РФ: статьи для школьников и студентов',
      },
    ],
  })),
);
</script>

<style lang="scss" scoped>
.highlight {
  -webkit-tap-highlight-color: #0000;
}
</style>
